import { useQuery, UseQueryResult } from "@tanstack/react-query";

import axios from "@/configs/axios";
import { getUserInfo } from "@/utils/session";

export interface Policy {
  status: number;
  policies: {
    effect: string;
    name: string;
    resource_action: {
      action: string[];
      applicationresource_id: string[];
    }[];
  }[];
}
export const useGetPolicies = (): UseQueryResult<Policy, Error> => {
  const getPolicies = async () => {
    const { userName } = getUserInfo();
    const url = `${process.env.REACT_APP_LOCAL_HOST}/policy?username=${userName}`;
    const {
      data: { resource },
      status,
    } = await axios.get(url);
    return { status, policies: resource.map((r: any) => ({ ...r })) };
  };
  const queryResult = useQuery<Policy, Error, Policy, string[]>({
    queryFn: getPolicies,
    queryKey: [],
  });
  return queryResult;
};
